/**
 * Generated by orval v7.14.0 🍺
 * Do not edit manually.
 * My API
 * Auto-generated Swagger docs
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  CheckoutArgsDto,
  CheckoutResponseDto,
  CollectionDto
} from './generated.schemas';





export const gelatoProductsControllerGetAllProducts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/gelato/products`,options
    );
  }




export const getGelatoProductsControllerGetAllProductsQueryKey = () => {
    return [
    `https://photosshop.onrender.com/gelato/products`
    ] as const;
    }

    
export const getGelatoProductsControllerGetAllProductsQueryOptions = <TData = Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGelatoProductsControllerGetAllProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>> = ({ signal }) => gelatoProductsControllerGetAllProducts({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GelatoProductsControllerGetAllProductsQueryResult = NonNullable<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>>
export type GelatoProductsControllerGetAllProductsQueryError = AxiosError<unknown>


export function useGelatoProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>,
          TError,
          Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGelatoProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>,
          TError,
          Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGelatoProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGelatoProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGelatoProductsControllerGetAllProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const gelatoProductsControllerGetProductById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/gelato/products/${id}`,options
    );
  }




export const getGelatoProductsControllerGetProductByIdQueryKey = (id?: string,) => {
    return [
    `https://photosshop.onrender.com/gelato/products/${id}`
    ] as const;
    }

    
export const getGelatoProductsControllerGetProductByIdQueryOptions = <TData = Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGelatoProductsControllerGetProductByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>> = ({ signal }) => gelatoProductsControllerGetProductById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GelatoProductsControllerGetProductByIdQueryResult = NonNullable<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>>
export type GelatoProductsControllerGetProductByIdQueryError = AxiosError<unknown>


export function useGelatoProductsControllerGetProductById<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>,
          TError,
          Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGelatoProductsControllerGetProductById<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>,
          TError,
          Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGelatoProductsControllerGetProductById<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGelatoProductsControllerGetProductById<TData = Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof gelatoProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGelatoProductsControllerGetProductByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyProductsControllerGetAllProducts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/shopify/products`,options
    );
  }




export const getShopifyProductsControllerGetAllProductsQueryKey = () => {
    return [
    `https://photosshop.onrender.com/shopify/products`
    ] as const;
    }

    
export const getShopifyProductsControllerGetAllProductsQueryOptions = <TData = Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopifyProductsControllerGetAllProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>> = ({ signal }) => shopifyProductsControllerGetAllProducts({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopifyProductsControllerGetAllProductsQueryResult = NonNullable<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>>
export type ShopifyProductsControllerGetAllProductsQueryError = AxiosError<unknown>


export function useShopifyProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopifyProductsControllerGetAllProducts<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetAllProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopifyProductsControllerGetAllProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyProductsControllerGetProductById = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/shopify/products/${id}`,options
    );
  }




export const getShopifyProductsControllerGetProductByIdQueryKey = (id?: string,) => {
    return [
    `https://photosshop.onrender.com/shopify/products/${id}`
    ] as const;
    }

    
export const getShopifyProductsControllerGetProductByIdQueryOptions = <TData = Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopifyProductsControllerGetProductByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>> = ({ signal }) => shopifyProductsControllerGetProductById(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopifyProductsControllerGetProductByIdQueryResult = NonNullable<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>>
export type ShopifyProductsControllerGetProductByIdQueryError = AxiosError<unknown>


export function useShopifyProductsControllerGetProductById<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>,
          TError,
          Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyProductsControllerGetProductById<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>,
          TError,
          Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyProductsControllerGetProductById<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopifyProductsControllerGetProductById<TData = Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyProductsControllerGetProductById>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopifyProductsControllerGetProductByIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyCollectionsControllerGetAllCollections = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/shopify/collections`,options
    );
  }




export const getShopifyCollectionsControllerGetAllCollectionsQueryKey = () => {
    return [
    `https://photosshop.onrender.com/shopify/collections`
    ] as const;
    }

    
export const getShopifyCollectionsControllerGetAllCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopifyCollectionsControllerGetAllCollectionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>> = ({ signal }) => shopifyCollectionsControllerGetAllCollections({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopifyCollectionsControllerGetAllCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>>
export type ShopifyCollectionsControllerGetAllCollectionsQueryError = AxiosError<unknown>


export function useShopifyCollectionsControllerGetAllCollections<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetAllCollections<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetAllCollections<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopifyCollectionsControllerGetAllCollections<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetAllCollections>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopifyCollectionsControllerGetAllCollectionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyCollectionsControllerGetCollectionProducts = (
    id: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/shopify/collections/${id}/products`,options
    );
  }




export const getShopifyCollectionsControllerGetCollectionProductsQueryKey = (id?: string,) => {
    return [
    `https://photosshop.onrender.com/shopify/collections/${id}/products`
    ] as const;
    }

    
export const getShopifyCollectionsControllerGetCollectionProductsQueryOptions = <TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError = AxiosError<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopifyCollectionsControllerGetCollectionProductsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>> = ({ signal }) => shopifyCollectionsControllerGetCollectionProducts(id, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopifyCollectionsControllerGetCollectionProductsQueryResult = NonNullable<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>>
export type ShopifyCollectionsControllerGetCollectionProductsQueryError = AxiosError<unknown>


export function useShopifyCollectionsControllerGetCollectionProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError = AxiosError<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetCollectionProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetCollectionProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopifyCollectionsControllerGetCollectionProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError = AxiosError<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopifyCollectionsControllerGetCollectionProductsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyCollectionsControllerGetCollectionsWithProducts = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CollectionDto[]>> => {
    
    
    return axios.get(
      `https://photosshop.onrender.com/shopify/collections/with-products/all`,options
    );
  }




export const getShopifyCollectionsControllerGetCollectionsWithProductsQueryKey = () => {
    return [
    `https://photosshop.onrender.com/shopify/collections/with-products/all`
    ] as const;
    }

    
export const getShopifyCollectionsControllerGetCollectionsWithProductsQueryOptions = <TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShopifyCollectionsControllerGetCollectionsWithProductsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>> = ({ signal }) => shopifyCollectionsControllerGetCollectionsWithProducts({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShopifyCollectionsControllerGetCollectionsWithProductsQueryResult = NonNullable<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>>
export type ShopifyCollectionsControllerGetCollectionsWithProductsQueryError = AxiosError<unknown>


export function useShopifyCollectionsControllerGetCollectionsWithProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetCollectionsWithProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>,
          TError,
          Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShopifyCollectionsControllerGetCollectionsWithProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useShopifyCollectionsControllerGetCollectionsWithProducts<TData = Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shopifyCollectionsControllerGetCollectionsWithProducts>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShopifyCollectionsControllerGetCollectionsWithProductsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const shopifyCheckoutControllerCreateCheckout = (
    checkoutArgsDto: CheckoutArgsDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CheckoutResponseDto>> => {
    
    
    return axios.post(
      `https://photosshop.onrender.com/shopify/checkout`,
      checkoutArgsDto,options
    );
  }



export const getShopifyCheckoutControllerCreateCheckoutMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>, TError,{data: CheckoutArgsDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>, TError,{data: CheckoutArgsDto}, TContext> => {

const mutationKey = ['shopifyCheckoutControllerCreateCheckout'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>, {data: CheckoutArgsDto}> = (props) => {
          const {data} = props ?? {};

          return  shopifyCheckoutControllerCreateCheckout(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ShopifyCheckoutControllerCreateCheckoutMutationResult = NonNullable<Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>>
    export type ShopifyCheckoutControllerCreateCheckoutMutationBody = CheckoutArgsDto
    export type ShopifyCheckoutControllerCreateCheckoutMutationError = AxiosError<unknown>

    export const useShopifyCheckoutControllerCreateCheckout = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>, TError,{data: CheckoutArgsDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof shopifyCheckoutControllerCreateCheckout>>,
        TError,
        {data: CheckoutArgsDto},
        TContext
      > => {

      const mutationOptions = getShopifyCheckoutControllerCreateCheckoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
